import axios from "axios";

// lsq lapp names for different cases
const lappNames = {
  OTP: "da_46725_9f5d7299",
  CREATE: "da_46725_2bcedf60",
  MAVIS: "da_46725_b19b105f",
  UPDATE_LEAD:"da_46725_89cae1b0",
  CRIF : "da_46725_db9e18ed"

};

// lsq base URL
const LSQ_BASE_URL =
  "https://f0jz2wbufc.execute-api.ap-south-1.amazonaws.com/default/lapp-proxy";

// call lsq api
export const callLSQLapp = async (payload, lappType, param) => {
  try {
    // console.log("payload, lappType, param", { payload, lappType, param });
    // create payload
    let proxyPayload = {
      method: "post",
      orgId: "46725",
      params: {
        stage: "Live",
        name: lappNames[lappType],
      },
      data: {
        lappBody: payload,
      },
    };

    // add params
    if (param) {
      const mergedObject = Object.assign({}, proxyPayload.params, param);
      proxyPayload.params = mergedObject;
    }
    // console.log("proxyPayload", proxyPayload);
    const res = await axios.post(LSQ_BASE_URL, proxyPayload);
    return res;
  } catch (error) {
    console.log("callLSQLapp error", error);
  }
};

export function getLsqLeadBody(formData) {
  let Config = {
    subProduct: "mx_Subcategory_product",
    pincode: "mx_Pincode",
    token: "mx_Token",
    lastName: "LastName",
    DateOfBirthValue: "mx_Date_of_Birth",
    firstName: "FirstName",
    email: "EmailAddress",
    // mobile: "Mobile",
    leadPhone: "Mobile",
    profession: "mx_Employment_Type",
    salary: "mx_Take_Home_Salary",
    // minloanamt: "mx_HL_Required_Loan_Amount",
    isChecked: "mx_Iauthorization",
    // ExistingObligations: "mx_Obligation_Amount",
    MonthlyIncome: "mx_Gross_Monthly_Income",
    salary_mode: "mx_Salary_Received_in_Cash",
    LoanTenure: "mx_Tenure_in_Years",
    co_applicant: "mx_CoApplicant",
    co_applicant_salary: "mx_Co_Applicant_Salary",
    utm_term: "mx_Utm_Terms",
    utm_lms: "mx_utm_lms",
    utm_campaign: "SourceCampaign",
    utm_content: "SourceContent",
    loanamount: "mx_HL_Required_Loan_Amount",
    Obligation: "mx_Obligation_Amount",
    GrossFamilyIncome: "mx_Gross_Family_Income",

    PurposeOfLoan: "mx_Purpose",

    CityName: "mx_City",
    EducationQualification: "mx_HighestEducation_Qualification",

    DND: "mx_DND_NDNC",
    COMPANY_LOCATION: "mx_Customer_Location",

    Age: "mx_Age",
    gclid: "mx_Gclid",
    Referral: "mx_Referral",
    InterestRate: "mx_Interest_Rate",
    FOIR: "mx_FOIR",
    EligibilityReason: "mx_Eligibility_Reason",
    // EmiPerLakh: "mx_Offer_EMI",
    CompleteUrl: "mx_UTM_URL_Details",
    calTenure: "mx_Current_EMI",
    ApproximateCostOfProperty: "mx_Property_Value",
    // RequiredLoanAmount: "mx_Loan_Amount",
    PropertyIdentified: "mx_Property_Identified",
    CampaignId: "mx_Campaign_ID",
    ApiProductName: "mx_Product",
    serviceType:"mx_Service_Type",
    campaignRegion:"mx_Campaign_Region",
    ParentProduct: "mx_Parent_Product",
    displayLoanAmount: "mx_Offer_Amount",
    displayTenure: "mx_Current_EMI",
    displayEmiPayable: "mx_Offer_EMI",
    displayRate: "mx_Offer_Rate_of_Interest",
    cibilscore: "mx_cibil_score",
    incomeSegment: "mx_income_segment_score",
    reportId: "mx_Criff_Report_ID",
    FBClickID: "mx_FB_Click_ID",
    FBPixelID: "mx_FB_Pixel_ID",
    CriffTriggered: "mx_Criff_Triggered",
    criffResponse: "mx_Criff_Response_Message",
    pan: "mx_PAN",

    User_Agent: "mx_Lead_Device",

    CompanyType: "mx_Company_Type",
    ModeOfLead: "Source",
    utm_medium: "SourceMedium",
    utm_source: "mx_Source_UTM",
    empName: "mx_Company_Name",
    solId: "mx_Sol_ID",
    branch: "mx_Branch",
    need : "mx_Interested_Products"
  };
  let LeadBody = [];
  // if (TypeOfLoan == "HL") {
  Object.keys(Config).forEach((key) => {
    if (formData.hasOwnProperty(key) && formData[key])
      LeadBody.push({
        Attribute: Config[key],
        Value: formData[key],
      });
  });
  // }
  return LeadBody;
}



const dateFormater = (dateStr) => {
  if (!dateStr) {
    return "";
  }
  // const dateStr = "29042023";
  const day = dateStr.substr(0, 2);
  const month = dateStr.substr(2, 2);
  const year = dateStr.substr(4, 4);

  const formattedDateStr = `${year}-${month}-${day}`;

  // console.log(formattedDateStr);
  return formattedDateStr;
};

export function getFirstNameLastName(name) {
  const names = name.split(" ");
  const firstName = names[0];
  const lastName = names.length > 1 ? names[names.length - 1] : "";

  return {
    firstName,
    lastName,
  };
}


export async function DataLayerEvent(ActionVal) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "custom_event",
    eventCategory: "seniorcitizen_campaign",
    eventAction: ActionVal,
    eventLabel: 'NA',
  });
}

// dataLayer.push({'event':'custom_event',
// 'eventCategory':'seniorcitizen_campaign',
// 'eventAction':'generate_otp_clicked',
// 'eventLabel':'NA'
// });

// dataLayer.push({'event':'custom_event',
// 'eventCategory':'seniorcitizen_campaign',
// 'eventAction':'get_in_touch_clicked',
// 'eventLabel':'NA'
// });

// dataLayer.push({'event':'custom_event',
// 'eventCategory':'seniorcitizen_campaign',
// 'eventAction':'calculate_the_fd_interest_clicked',
// 'eventLabel':'NA'
// });

// dataLayer.push({'event':'custom_event',
// 'eventCategory':'seniorcitizen_campaign',
// 'eventAction':'thankyou_page',
// 'eventLabel':'NA'
// });